// routes/_app.membership.current.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'

const getClientModule = () => import('src/clientRoutes/_app.membership.current')

export const handle = { name: 'membership/current', hideMembershipBanner: true }

export function loader() {
  return null
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  const { loader } = await getClientModule()
  return loader(args)
}

clientLoader.hydrate = true

export default function Page() {
  return null
}
